import { render, staticRenderFns } from "./PublishedModalRoot.vue?vue&type=template&id=13dc7f9c&scoped=true&"
import script from "./PublishedModalRoot.vue?vue&type=script&lang=js&"
export * from "./PublishedModalRoot.vue?vue&type=script&lang=js&"
import style0 from "./PublishedModalRoot.vue?vue&type=style&index=0&id=13dc7f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dc7f9c",
  null
  
)

export default component.exports